<template>
    <div id="biodigestor-history-datatable-widget-component">
        <WidgetWrapperComponent :title="$t('following_actions')" id-widget="biodigestor-history-datatable-widget">
            <template v-slot:default>
                <DateRangePickerComponent :date_range="date_range" class="mb-4" v-on:update="handleDateRangeUpdate" />
                <v-data-table v-model="historicalActivity" :items="historicalActivity" :headers="headers" :loading="fetchingActivity">
                    <template v-slot:item.action="{ item }">
                        <div class="d-flex align-center gap-3" :class="`text-${item.color || 'default'}`">
                            <v-icon>
                                {{ item.icon }}
                            </v-icon>
                            {{ $t(item.action) }}
                        </div>
                    </template>
                    <template v-slot:item.date="{ item }">
                        <v-chip small outlined class="text--light">
                            {{ formatDate(item.date) }}
                        </v-chip>
                    </template>
                </v-data-table>
            </template>
        </WidgetWrapperComponent>
    </div>
</template>
<script>
import deviceRepository from '@/repositories/DeviceRepository'
import moment from 'moment'
import DateRangePickerComponent from '@/components/global/picker/DateRangePickerComponent.vue'
import WidgetWrapperComponent from '@/components/global/wrapper/WidgetWrapperComponent.vue'

export default {
    name: 'BiodigestorHistoryDatatableWidgetComponent',
    components: {
        DateRangePickerComponent,
        WidgetWrapperComponent,
    },
    props: {
        asset: {
            type: Object,
            required: true,
        },
        device: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            date_range: {
                startDate: moment().clone().startOf('day').subtract(1, 'day').toDate(),
                endDate: moment().toDate(),
            },
            fetchingActivity: false,
            historicalActivity: [],
            headers: [
                {
                    text: this.$t('actions'),
                    value: 'action',
                    key: 'action',
                    key_database: 'action',
                    visible: true,
                    configurable: true,
                    sortable: true,
                },
                {
                    text: this.$t('date_releve'),
                    value: 'date',
                    key: 'date',
                    key_database: 'date',
                    visible: true,
                    configurable: true,
                    sortable: true,
                },
            ],
        }
    },
    methods: {
        formatDate(date) {
            return moment(date).format('YYYY-MM-DD HH:mm:ss')
        },
        async fetchHistoricActivity() {
            this.fetchingActivity = true
            const params = new URLSearchParams({
                date_start: moment(this.date_range.startDate).format('YYYY-MM-DD 00:00:00'),
                date_end: moment(this.date_range.endDate).format('YYYY-MM-DD 23:59:59'),
            })
            return deviceRepository
                .getBiodigestorHistoricalByDevice(this.device.device_number, params)
                .then((success) => {
                    this.historicalActivity = success.data.data.map((historic) => JSON.parse(historic))
                })
                .catch((error) => {
                    this.manageError(error)
                })
                .finally(() => {
                    this.fetchingActivity = false
                })
        },
        handleDateRangeUpdate(dates) {
            this.date_range = dates
            this.fetchHistoricActivity()
        },
    },
    async mounted() {
        await this.fetchHistoricActivity()
    },
}
</script>
